import DataGrid2 from '../..';
import {
	EBatchFieldTypes,
	IBatchChangesEventArgs,
	IBatchOperation
} from '../../../../entities/EventArgs';
import { DataGridDataTypes } from '../../entities';

export async function onChangesChange(this: DataGrid2, changes) {
	if (this.editing.mode !== 'batch') {
		return;
	}

	const newBatchOperations: IBatchOperation[] = changes.map(change => ({
		uniqueFieldValue: change.key,
		type: change.type === 'remove' ? 'delete' : change.type,
		fields: Object.entries(change.data || {}).map(([columnName, value]) => ({
			columnName,
			value,
			type: colDataTypeToBatchType(
				this.__bcDataGridRef.current.instance().columnOption(columnName, 'dataType')
			)
		}))
	}));

	const payload: IBatchChangesEventArgs = {
		batchOperations: newBatchOperations,
		cancel: false
	};

	await this.emit('event:OnBatchChanges', payload);

	this.batchOperations.forEach(batch => {
		const batchIndex = newBatchOperations.findIndex(
			x => x.uniqueFieldValue === batch.uniqueFieldValue
		);
		if (batchIndex > -1) {
			newBatchOperations[batchIndex].fields.push(
				...batch.fields.filter(
					f =>
						!newBatchOperations[batchIndex].fields.find(
							i => i.columnName == f.columnName
						)
				)
			);
		} else {
			newBatchOperations.push({ ...batch });
		}
	});

	this.__proxyChanged.batchOperations = newBatchOperations;
}

const colDataTypeToBatchType = (type: DataGridDataTypes): EBatchFieldTypes => {
	switch (type) {
		case DataGridDataTypes.boolean:
			return EBatchFieldTypes.Boolean;
		case DataGridDataTypes.date:
			return EBatchFieldTypes.DateTime;
		case DataGridDataTypes.dateRange:
			return EBatchFieldTypes.Array;
		case DataGridDataTypes.dateTime:
			return EBatchFieldTypes.DateTimeOffset;
		case DataGridDataTypes.select:
		case DataGridDataTypes.multiLanguage:
			return EBatchFieldTypes.Object;
		case DataGridDataTypes.number:
			return EBatchFieldTypes.Integer;
		case DataGridDataTypes.text:
			return EBatchFieldTypes.String;
		default:
			return EBatchFieldTypes.Unknown;
	}
};
